/** DateTime Unit. Base on Millisecond. */
export const DATETIME_UNIT = {
  MILLISECOND: 1,
  SECOND: 1000,
  MINUTE: 60000,
  HOUR: 3600000,
  DAY: 86400000,
  MONTH: 2592000000,
  YEAR: 31104000000,
} as const;

/** Day Unit. Base on Day. */
export const DAY_UNIT = {
  DAY: 1,
  WEEK: 7,
  MONTH: 30,
} as const;
